import { makeStyles } from '@material-ui/core';

const FooterStyles = makeStyles(() => ({
  footer: {
    bottom: 0,
    left: 0,
    right: 0,
    width: '100%',
    textAlign: 'center',
    height: '1em',
    '& .link': {
      color: 'black',
      textDecoration: 'underline',
      fontSize: '14px',
    },
  },
}));

export default FooterStyles;
